import { useSuspenseQuery } from '@tanstack/react-query';
import { appQueries } from '../../api/app.api';
import { EasyLifeLicenseSku, skuMap } from '@easylife365/react';

const devSku = getDevSku();

export default function useLicenseInfo() {
  const { data: isAppEnabledResponse } = useSuspenseQuery(appQueries.isAppEnabled);

  const sku = devSku ?? isAppEnabledResponse.sku;

  return {
    sku,
    isBasic: sku === EasyLifeLicenseSku.Basic,
    isProfessional: sku === EasyLifeLicenseSku.Professional || sku === EasyLifeLicenseSku.Trial,
    skuName: skuMap[sku],
    remainingDays: isAppEnabledResponse.expirationInfo?.remainingDays ?? 31,
  };
}

function getDevSku(): EasyLifeLicenseSku | undefined {
  if (import.meta.env.DEV && import.meta.env.VITE_DEV_LICENSE) {
    const override = import.meta.env.VITE_DEV_LICENSE as keyof typeof EasyLifeLicenseSku;
    if (override in EasyLifeLicenseSku) {
      return EasyLifeLicenseSku[override];
    }
  }
  return undefined;
}
